import { graphql } from 'react-relay/legacy';

export default graphql`
    query headerRootQuery(
        $hasUserId: Boolean!
        $hasTradeUserId: Boolean!
        $previewKey: String = ""
        $userId: String!
        $userIds: [String]!
        $isClient: Boolean!
        $fetchRegionalInfo: Boolean!
        $zipCode: String!
        $userCountryCode: String = ""
        $hasSessionCountryCode: Boolean!
        $localRecentHistoryItemIds: [String] = []
        $fetchUserRecentHistoryItem: Boolean = false
    ) {
        viewer {
            ...Header_viewer
        }
    }
`;

export const initialVariables = {
    hasUserId: false,
    hasTradeUserId: false,
    previewKey: '',
    fetchRegionalInfo: false,
    userId: '',
    userIds: [],
    isClient: false,
    zipCode: '',
    userCountryCode: '',
    hasSessionCountryCode: false,
};
